import React from "react";
import { Container, Row, Col } from "reactstrap";
import Card from "react-bootstrap/Card";
import { HapticLink as Link } from "../utils/haptics";

const About = () => {
  return (
    <div
      className="about-contactus-page"
      style={{ backgroundColor: "black", minHeight: "100vh", color: "white" }}
    >
      <div className="text-center py-5" style={{ backgroundColor: "black" }}>
        <div className="container">
          <h1 className="mb-4">About Us</h1>
          <p className="lead mb-4" style={{ color: "white" }}>
            Building the best sports betting assistant
          </p>
        </div>
      </div>

      <Container>
        <Row className="my-5">
          <Col xs={12} md={10} lg={10} xl={12} className="mx-auto">
            <h2 className="mb-4">Our Story</h2>
            <p>
              The Form Bettor was founded with a simple mission: to make sports betting 
              research more accessible and efficient for everyone. We believe that informed 
              betting decisions shouldn't require hours of research across multiple platforms.
              <br /><br />
              Our platform combines advanced analytics with an intuitive interface, 
              allowing bettors to make well-informed decisions quickly and efficiently.
            </p>
          </Col>
        </Row>

        <hr className="my-5" style={{ borderColor: 'white' }} />

        <Row className="my-5">
          <Col xs={12} md={10} lg={8} xl={12} className="mx-auto">
            <h2 className="mb-4">Contact Us</h2>
            <p>
              Have questions or suggestions? We'd love to hear from you.
              <br />
              Email us at: brian@theformbettor.com
              <br />
              or for a quick response, join our discord server: <a href="https://discord.gg/eD5C4CfD25" style={{ color: 'white' }}>https://discord.gg/eD5C4CfD25</a>
            </p>
            <Link to="/" className="btn btn-primary mt-3">
              Back to Home
            </Link>
          </Col>
        </Row>
      </Container>

      <footer className="text-center py-3 mt-5">
        <p>&copy; 2025 The Form Bettor LLC. All rights reserved.</p>
      </footer>
    </div>
  );
};

export default About;